import { createAction, createAsyncAction } from 'store/actionConfigs';
import type { NotificationListQuery, NotificationPage, NotificationUnreadQuery } from 'types/models';
import { PREFIX_ACTIONS } from './constants';

const getNotifications = createAsyncAction<NotificationListQuery, NotificationPage>(PREFIX_ACTIONS + 'getNotifications');
const setNotifications = createAction<NotificationPage>(PREFIX_ACTIONS + 'setNotifications');
// success payload shape is inconsistent with state.unreadCount's initial value (see reducers.ts) — kept loose, not "fixed"
const countNotificationUnread = createAsyncAction<NotificationUnreadQuery, any>(PREFIX_ACTIONS + 'countNotificationUnread');

const notificationActions = {
  getNotifications,
  setNotifications,
  countNotificationUnread,
};

export default notificationActions;
